import React from 'react';
import PropTypes from 'prop-types';

import Day from './Day';

import s from './DateRange.css';


const DateRange = ({ dates, handleTimeSlotSelection }) => {
  if (!dates) {
    return false;
  }
  // Map passed dateRange to CalendarTimeSlot.
  const calendarDay = dates.map((date) => {
    // If the date is disabled, don't return html.
    if (!date.enabled) {
      return null;
    } else {
      return (
        <Day
          key={date.date}
          date={date}
          handleTimeSlotSelection={handleTimeSlotSelection}
        />
      );
    }
  });

  return (
    <div className={s.component}>
      {calendarDay}
    </div>
  );
};

DateRange.propTypes = {
  dates: PropTypes.array,
  handleTimeSlotSelection: PropTypes.func,
};

export default DateRange;



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/Scheduling/Calendar/DateRange.js